import { useMutation } from "@tanstack/react-query";
import qcareApi from "./qcareApi";
import { ModelSupplier } from "../interfaces/interfaces";
import { GrowerWithoutId } from "../interfaces/interfaces.auth";

interface ModelId {
    id: string,
    model: ModelSupplier,
}

interface CreateGrower extends ModelId {
    name: string,
    ggn_number: string,
}

interface EditGrower extends CreateGrower{
    growerId: string,
}

interface CreateField extends ModelId {
    growerId: string,
    name: string,
    country: string,
    city: string,
    coords: {
        lat: number,
        lon: number,
    },
}

interface EditField extends CreateField {
    fieldId: string
}

interface RemoveGrower extends ModelId {
    growerId: string,
}

interface RemoveField extends ModelId {
    growerId: string,
    fieldId: string,
}

interface SaveManyGrowers extends ModelId {
    growers: GrowerWithoutId[],
}

const createGrower = async (query: CreateGrower) => {
    const { id, ...body } = query
    const { data } = await qcareApi.post(`/grower/create-grower/${id}`, body);
    return data
}

const editGrower = async ( query:EditGrower ) => {
    const { id, ...body } = query
    const { data } = await qcareApi.put(`/grower/edit-grower/${id}`, body);
    return data
}

const createField = async (query: CreateField) => {
    const { id, ...body } = query
    const { data } = await qcareApi.post(`/grower/add-field/${id}`, body);
    return data
}

const editField = async ( query:EditField ) => {
    const { id, ...body } = query
    const { data } = await qcareApi.put(`/grower/edit-field/${id}`, body);
    return data
}

const removeGrower = async (query: RemoveGrower) => {

    const { id, ...body } = query
    const { data } = await qcareApi.put(`/grower/remove-grower/${id}`, body);

    return data
}

const removeField = async ( query:RemoveField ) => {
    const { id, ...body } = query
    const { data } = await qcareApi.put(`/grower/remove-field/${id}`, body);
    return data
}

const saveManyGrowers = async (query: SaveManyGrowers) => {
    const { id, ...body } = query
    const { data } = await qcareApi.post(`/grower/save-many-growers/${id}`, body);
    return data
}

// ------------------------- HOOKS -------------------------

export const useCreateGrower = () => {
    return useMutation(createGrower)
}

export const useEditGrower = () => {
    return useMutation(editGrower)
}

export const useCreateField = () => {
    return useMutation(createField)
}

export const useEditField = () => {
    return useMutation(editField)
}

export const useRemoveGrower = () => {
    return useMutation(removeGrower)
}

export const useRemoveField = () => {
    return useMutation(removeField)
}

export const useSaveManyGrowers = () => {
    return useMutation(saveManyGrowers)
}